import React, { useContext, useState } from 'react'
import styles from '../styles/navbar.module.css'
import StateContext from '../context/state/StateContext'
import { formatDistanceToNow } from 'date-fns'; // Import the function from date-fns
import SideContent from './SideContent';

const NotificationContainer = ({ open }) => {

    const { notifications, token, setNotifications, setLoading, setDetail, tickets } = useContext(StateContext)

    const [activeFilter, setActiveFilter] = useState('All');
    const [detailModal, setDetailModal] = useState(false)
    const [taskId, setTaskId] = useState('');
    const [ticketContent, setTicketContent] = useState('');
    

    // Filter notifications based on the active filter
    const filteredNotifications = notifications.filter((item) =>
        activeFilter === 'All' ? true : item.action === activeFilter
    );

    const totals = {
        All: notifications.length,
        Generated: notifications.filter((item) => item.action === 'Generated').length,
        Updates: notifications.filter((item) => item.action === 'Updates').length,
        Comments: notifications.filter((item) => item.action === 'Comments').length,
        Requests: notifications.filter((item) => item.action === 'Requests').length,
    };

    const handleMarkAsRead = async (id) => {
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + `api/ticket/markAsRead/${id}`, {
                method: 'PUT',
                headers: {
                    'auth-token': `${token}`
                },
            });

            const json = await response.json();
            if (json.success) {
                setNotifications((prev) =>
                    prev.map((notification) =>
                        notification.id === id ? { ...notification, isRead: true } : notification
                    )
                );
            }
        } catch (error) {
            console.error('Error marking notification as read:', error);
        }
    };

    const handleMarkAllAsRead = async () => {
        try {
            setLoading({ open: true, text: "Updating" })
            const response = await fetch(process.env.REACT_APP_API_URL + 'api/ticket/markAllAsRead', {
                method: 'PUT',
                headers: {
                    'auth-token': `${token}`
                },
            });

            const json = await response.json()
            if (json.success) {
                setNotifications((prev) =>
                    prev.map((notification) => ({ ...notification, isRead: true }))
                );
            }
        } catch (error) {
            console.error('Error marking all notifications as read:', error);
        } finally {
            setLoading({ open: false, text: "" })
        }
    };

    const hasUnreadNotifications = notifications && notifications.some((notification) => !notification.isRead);    

    const deleteAll = async () => {
        try {
            setLoading({ open: true, text: "Deleting" })
            const response = await fetch(process.env.REACT_APP_API_URL + `api/ticket/deleteAllNotifications`, {
                method: 'DELETE',
                headers: {
                    'auth-token': `${token}`
                },
            });

            const json = await response.json();
            if (json.success) {
                setNotifications([])
            }
        } catch (error) {
            console.error('Error marking notification as read:', error);
        } finally{
            setLoading({ open: false, text: "" })
        }
    }
    

    return (
        <>
            <SideContent data={ticketContent} open={detailModal} close={setDetailModal} />
            <div className={`${styles.notification_container} ${open ? styles.active : ''}`}>
                <div className={styles.noti_header}>
                    <h3>Notifications</h3>
                    <div className="d-flex align-items-center" style={{gap: ".8em"}}>
                        {hasUnreadNotifications && <button onClick={handleMarkAllAsRead}>Mark all as read</button>}
                        {notifications && notifications.length > 0 && <button onClick={deleteAll}>Delete All</button>}
                    </div>
                </div>
                <div style={{ padding: "0 1em" }}>
                    <div className={styles.noti_filters}>
                        <button
                            total={totals.All}
                            className={`${styles.filter_button} ${activeFilter === 'All' ? styles.active : ''}`}
                            onClick={() => setActiveFilter('All')}
                        >
                            All
                        </button>
                        <button
                            total={totals.Generated}
                            className={`${styles.filter_button} ${activeFilter === 'Generated' ? styles.active : ''}`}
                            onClick={() => setActiveFilter('Generated')}
                        >
                            Generated
                        </button>
                        <button
                            total={totals.Updates}
                            className={`${styles.filter_button} ${activeFilter === 'Updates' ? styles.active : ''}`}
                            onClick={() => setActiveFilter('Updates')}
                        >
                            Updates
                        </button>
                        <button
                            total={totals.Comments}
                            className={`${styles.filter_button} ${activeFilter === 'Comments' ? styles.active : ''}`}
                            onClick={() => setActiveFilter('Comments')}
                        >
                            Comments
                        </button>
                        <button
                            total={totals.Requests}
                            className={`${styles.filter_button} ${activeFilter === 'Requests' ? styles.active : ''}`}
                            onClick={() => setActiveFilter('Requests')}
                        >
                            Requests
                        </button>
                    </div>
                </div>
                <div className={styles.noti_list}>
                    {filteredNotifications && filteredNotifications.length > 0 ? filteredNotifications.map((item, index) => {
                        return <>
                            <div onClick={() => {
                                if (!item.isRead) {
                                    handleMarkAsRead(item.id)
                                }
                            }} key={index} className={`${styles.noti_item} ${item.comment ? 'align-items-start' : ''}`}>
                                {item.sender.picture ?
                                    <div className={styles.img}>
                                        <img
                                            src={process.env.REACT_APP_API_URL + `uploads/${item.sender.picture}`} className="img-fluid" alt="" />
                                    </div> : <i className={`bx bxs-user-circle ${styles.img1}`}></i>
                                }
                                <div className='w-100'>
                                    <div className={styles.noti_info}>
                                        {item.isRead ? null : <div className={styles.read}></div>}
                                        <div className='w-100'>
                                            <h6 className={styles.h6}>{item.title}</h6>
                                            <p>{item.message}</p>
                                        </div>
                                        <span className={styles.timestamp}>
                                            {formatDistanceToNow(new Date(item.createdAt), { addSuffix: true })}
                                        </span>
                                    </div>
                                    {item.comment && <div className={styles.comment}>
                                        <p>{item.comment.slice(0, 100)}...</p>
                                    </div>}
                                </div>
                            </div>
                            
                        </>
                    }) :
                        <div className="d-flex align-items-center justify-content-center h-100 w-100">
                            <h6>No Notification Found</h6>
                        </div>
                    }

                </div>
            </div>

        </>
    )
}

export default NotificationContainer
